import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatTabsModule, MatButtonModule, MatInputModule, MatFormFieldModule, MatMenuModule, MatTableModule, MatIconModule, MatListModule, MatTooltipModule, MatAutocompleteModule, MatStepperModule, MatChipsModule } from '@angular/material'
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { ServiceLiveDashboardRoutingModule } from './service-live-dashboard-routing.module';
import { SmsPdpServiceLiveDashboardComponent } from './sms-pdp-service-live-dashboard/sms-pdp-service-live-dashboard.component';
import { RrmsServiceLiveDashboardComponent } from './rrms-service-live-dashboard/rrms-service-live-dashboard.component';
import { RrmsServiceLiveDataTableComponent } from './rrms-service-live-data-table/rrms-service-live-data-table.component';
import { AddSmsPdpLiveServiceConfigurationComponent } from './add-sms-pdp-live-service-configuration/add-sms-pdp-live-service-configuration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddRrmsLiveServiceConfigurationComponent } from './add-rrms-live-service-configuration/add-rrms-live-service-configuration.component';
import { EditEcowasBusinessConfigTableComponent } from './Table/edit-ecowas-business-config-table/edit-ecowas-business-config-table.component';
import { EditEcowasWhitelistConfigTableComponent } from './Table/edit-ecowas-whitelist-config-table/edit-ecowas-whitelist-config-table.component';
import { EditEcowasConfigTableComponent } from './Table/edit-ecowas-config-table/edit-ecowas-config-table.component';
import { AddEcowasBusinessConfigComponent } from './add-ecowas-business-config/add-ecowas-business-config.component';
import { AddEcowasWhitelistConfigComponent } from './add-ecowas-whitelist-config/add-ecowas-whitelist-config.component';
import { AddEcowasConfigComponent } from './add-ecowas-config/add-ecowas-config.component';
import { ViewEcowasBusinessConfigTableComponent } from './view-ecowas-business-config-table/view-ecowas-business-config-table.component';
import { ViewEcowasConfigTableComponent } from './view-ecowas-config-table/view-ecowas-config-table.component';
import { ViewEcowasWhitelistConfigTableComponent } from './view-ecowas-whitelist-config-table/view-ecowas-whitelist-config-table.component';
import { ViewEcowasOrganizationTableComponent } from './view-ecowas-organization-table/view-ecowas-organization-table.component';
import { ViewProbeConfigTableComponent } from './view-probe-config-table/view-probe-config-table.component';
import { ViewEcowasInConfigTableComponent } from './view-ecowas-in-config-table/view-ecowas-in-config-table.component';
import { EditEcowasOrganizationConfigTableComponent } from './Table/edit-ecowas-organization-config-table/edit-ecowas-organization-config-table.component';
import { EditEcowasProbeConfigTableComponent } from './Table/edit-ecowas-probe-config-table/edit-ecowas-probe-config-table.component';
import { EditEcowasInConfigTableComponent } from './Table/edit-ecowas-in-config-table/edit-ecowas-in-config-table.component';
import { AddEcowasOrganizationConfigComponent } from './add-ecowas-organization-config/add-ecowas-organization-config.component';
import { AddProbeConfigComponent } from './add-probe-config/add-probe-config.component';
import { AddEcowasInConfigComponent } from './add-ecowas-in-config/add-ecowas-in-config.component';
import { SmsPdpServiceLiveDashboardDataTableComponent } from './sms-pdp-service-live-dashboard-data-table/sms-pdp-service-live-dashboard-data-table.component';
import { EditSmspdpConfigTableComponent } from './Table/edit-smspdp-config-table/edit-smspdp-config-table.component';
import { EditSmspdpEcowasConfigTableComponent } from './Table/edit-smspdp-ecowas-config-table/edit-smspdp-ecowas-config-table.component';
import { SmspdpThresholdConfigTableComponent } from './Table/smspdp-threshold-config-table/smspdp-threshold-config-table.component';
import { SmspdpLiveMappingTableComponent } from './Table/smspdp-live-mapping-table/smspdp-live-mapping-table.component';
import { ViewSmspdpConfigTableComponent } from './view-smspdp-config-table/view-smspdp-config-table.component';
import { ViewSmspdpEcowasConfigTableComponent } from './view-smspdp-ecowas-config-table/view-smspdp-ecowas-config-table.component';
import { ViewSmspdpLiveMappingTableComponent } from './view-smspdp-live-mapping-table/view-smspdp-live-mapping-table.component';
import { ViewSmspdpThresholdConfigTableComponent } from './view-smspdp-threshold-config-table/view-smspdp-threshold-config-table.component';

import { AddSmspdpConfigTableComponent } from './add-smspdp-config-table/add-smspdp-config-table.component';
import { AddSmspdpEcowasConfigComponent } from './add-smspdp-ecowas-config/add-smspdp-ecowas-config.component';
import { AddSmspdpLiveMapConfigComponent } from './add-smspdp-live-map-config/add-smspdp-live-map-config.component';
import { AddSmspdpThresholdConfigComponent } from './add-smspdp-threshold-config/add-smspdp-threshold-config.component';
import { AddWhitelistTableDataComponent } from './add-whitelist-table-data/add-whitelist-table-data.component';
import { DeleteRrmsServiceLiveDataComponent } from './delete-rrms-service-live-data/delete-rrms-service-live-data.component';
import { DeleteSmspdpLiveDataComponent } from './delete-smspdp-live-data/delete-smspdp-live-data.component';
import { AddRrmsServiceLiveCountryDetailsComponent } from './add-rrms-service-live-country-details/add-rrms-service-live-country-details.component';
import { AddSmspdpServiceLiveCountryDetailsComponent } from './add-smspdp-service-live-country-details/add-smspdp-service-live-country-details.component';
import { EditEcowasAllowedGtComponent } from './Table/edit-ecowas-allowed-gt/edit-ecowas-allowed-gt.component';
import { EditEcowasCcNdcComponent } from './Table/edit-ecowas-cc-ndc/edit-ecowas-cc-ndc.component';
import { EditEcowasMccMncComponent } from './Table/edit-ecowas-mcc-mnc/edit-ecowas-mcc-mnc.component';
import { EditEcowasinEcowasThresholdConfigComponent } from './Table/edit-ecowasin-ecowas-threshold-config/edit-ecowasin-ecowas-threshold-config.component';
import { EditRrmsProbedbAllowedGtComponent } from './Table/edit-rrms-probedb-allowed-gt/edit-rrms-probedb-allowed-gt.component';
import { EditRrmsProbedbCcNdcComponent } from './Table/edit-rrms-probedb-cc-ndc/edit-rrms-probedb-cc-ndc.component';
import { EditRrmsProbedbMccMncComponent } from './Table/edit-rrms-probedb-mcc-mnc/edit-rrms-probedb-mcc-mnc.component';
import { EditRrmsProbedbEcowasOrganizationComponent } from './Table/edit-rrms-probedb-ecowas-organization/edit-rrms-probedb-ecowas-organization.component';
import { DeleteWhitelistConfigComponent } from './delete-whitelist-config/delete-whitelist-config.component';
import { ViewProbAllowedGtComponent } from './view-prob-allowed-gt/view-prob-allowed-gt.component';
import { AddProbAllowedGtComponent } from './add-prob-allowed-gt/add-prob-allowed-gt.component';
import { DeleteProbAllowedGtComponent } from './delete-prob-allowed-gt/delete-prob-allowed-gt.component';
import { ViewAllowedGtComponent } from './view-allowed-gt/view-allowed-gt.component';
import { DeleteAllowedGtComponent } from './delete-allowed-gt/delete-allowed-gt.component';
import { AddAllowedGtComponent } from './add-allowed-gt/add-allowed-gt.component';
import { UploadRrmsServiceLiveDataComponent } from './upload-rrms-service-live-data/upload-rrms-service-live-data.component';
import { NetworkAdditionModule } from '../network-addition/network-addition.module';
import { SmsPdpLiveMappingDashboardComponent } from './sms-pdp-live-mapping-dashboard/sms-pdp-live-mapping-dashboard.component';
import { SmsPdpLiveMappingDashboardDataTableComponent } from './sms-pdp-live-mapping-dashboard-data-table/sms-pdp-live-mapping-dashboard-data-table.component';
import { AddSmsPdpLiveMappingConfigurationComponent } from './add-sms-pdp-live-mapping-configuration/add-sms-pdp-live-mapping-configuration.component';










@NgModule({
  declarations: [SmsPdpServiceLiveDashboardComponent,
     RrmsServiceLiveDashboardComponent,
      RrmsServiceLiveDataTableComponent,
      AddRrmsLiveServiceConfigurationComponent,
      AddSmsPdpLiveServiceConfigurationComponent,
        EditEcowasBusinessConfigTableComponent,
         EditEcowasWhitelistConfigTableComponent,
          EditEcowasConfigTableComponent,
          AddEcowasBusinessConfigComponent,
          AddEcowasWhitelistConfigComponent,
          AddEcowasConfigComponent,
          ViewEcowasBusinessConfigTableComponent,
          ViewEcowasConfigTableComponent,
          ViewEcowasWhitelistConfigTableComponent,
          ViewEcowasOrganizationTableComponent,
          ViewProbeConfigTableComponent,
          ViewEcowasInConfigTableComponent,
        EditEcowasOrganizationConfigTableComponent,
      EditEcowasProbeConfigTableComponent,
    EditEcowasInConfigTableComponent,
    AddEcowasOrganizationConfigComponent,
    AddProbeConfigComponent,
    AddEcowasInConfigComponent,
    SmsPdpServiceLiveDashboardDataTableComponent,
    EditSmspdpConfigTableComponent,
    EditSmspdpEcowasConfigTableComponent,
    SmspdpThresholdConfigTableComponent,
    SmspdpLiveMappingTableComponent,
    ViewSmspdpConfigTableComponent,
    ViewSmspdpEcowasConfigTableComponent,
    ViewSmspdpLiveMappingTableComponent,
    ViewSmspdpThresholdConfigTableComponent,
    
    AddSmspdpConfigTableComponent,
    AddSmspdpEcowasConfigComponent,
    AddSmspdpLiveMapConfigComponent,
    AddSmspdpThresholdConfigComponent,
    AddWhitelistTableDataComponent,
    DeleteRrmsServiceLiveDataComponent,
    DeleteSmspdpLiveDataComponent,
    AddRrmsServiceLiveCountryDetailsComponent,
    AddSmspdpServiceLiveCountryDetailsComponent,
    EditEcowasAllowedGtComponent,
    EditEcowasCcNdcComponent,
    EditEcowasMccMncComponent,
    EditEcowasinEcowasThresholdConfigComponent,
    EditRrmsProbedbAllowedGtComponent,
    EditRrmsProbedbCcNdcComponent,
    EditRrmsProbedbMccMncComponent,
    EditRrmsProbedbEcowasOrganizationComponent,
    DeleteWhitelistConfigComponent,
    ViewProbAllowedGtComponent,
    AddProbAllowedGtComponent,
    DeleteProbAllowedGtComponent,
    ViewAllowedGtComponent,
    DeleteAllowedGtComponent,
    AddAllowedGtComponent,
    UploadRrmsServiceLiveDataComponent,
    SmsPdpLiveMappingDashboardComponent,
    SmsPdpLiveMappingDashboardDataTableComponent,
    AddSmsPdpLiveMappingConfigurationComponent,
    
    
   
    ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ServiceLiveDashboardRoutingModule,
    MatStepperModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    MatListModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    MatTabsModule,
    MatInputModule,
    MatFormFieldModule,
    MatTableModule,
    MatAutocompleteModule,
    MatChipsModule,

    
      Ng4LoadingSpinnerModule.forRoot(),
  ],
  entryComponents: [
   EditEcowasBusinessConfigTableComponent,
   EditEcowasWhitelistConfigTableComponent,
   EditEcowasConfigTableComponent,
   EditEcowasInConfigTableComponent,
   EditEcowasOrganizationConfigTableComponent,
   EditEcowasProbeConfigTableComponent,
   ViewEcowasBusinessConfigTableComponent,
   ViewEcowasConfigTableComponent,
   ViewEcowasWhitelistConfigTableComponent,
   ViewProbeConfigTableComponent,
   ViewEcowasOrganizationTableComponent,  
   ViewEcowasInConfigTableComponent,

   
   EditSmspdpConfigTableComponent,
   EditSmspdpEcowasConfigTableComponent,
   SmspdpThresholdConfigTableComponent,
   SmspdpLiveMappingTableComponent,

   ViewSmspdpConfigTableComponent,
   ViewSmspdpEcowasConfigTableComponent,
   ViewSmspdpLiveMappingTableComponent,
   ViewSmspdpThresholdConfigTableComponent,

   AddWhitelistTableDataComponent,
   
   DeleteRrmsServiceLiveDataComponent,
   DeleteSmspdpLiveDataComponent,


   EditEcowasAllowedGtComponent,
   EditEcowasCcNdcComponent,
   EditEcowasMccMncComponent,
   EditEcowasinEcowasThresholdConfigComponent,
   EditRrmsProbedbAllowedGtComponent,
   EditRrmsProbedbCcNdcComponent,
   EditRrmsProbedbMccMncComponent,
   EditRrmsProbedbEcowasOrganizationComponent,
   DeleteWhitelistConfigComponent,
   ViewProbAllowedGtComponent,
   AddProbAllowedGtComponent,
   DeleteProbAllowedGtComponent,
   ViewAllowedGtComponent,
   AddAllowedGtComponent,
   DeleteAllowedGtComponent,
   UploadRrmsServiceLiveDataComponent

   
  ],
  exports:[

  ]
})
export class ServiceLiveDashboardModule { }
